import { useRef } from "react";
import HomeFilter from "./HomeFilter";
import HomeCarpetLoader from "./HomeCarpetLoader";
import InfiniteScroll from "react-infinite-scroll-component";
import ProfileItem from "./ProfileItem";
import usePrepareLink from "../../../hooks/usePrepareLink";
import { useEffect, useLayoutEffect, useState } from "react";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { MemberCarpet } from "../../../typings/member";
import { getHomeMembers } from "../../../services/memberService";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { HomeCarpetFilterCategory } from "../../../helpers/Enums";
import { getHomeMembersByTag } from "./../../../services/memberService";
import { GET_PARAMS, GET_POPUPS } from "../../../const/router";
import { setNeedToRefresh } from "../../../redux/carpet";
import "react-loading-skeleton/dist/skeleton.css";
import EmptyCarpetPlaceHolder from "../../../components/EmptyCarpetPlaceHolder";
import EndOfFeedCarpet from "./EndOfFeedCarpet";
import { HOMEPAGE } from "../../../navigation/Constants";
import AdBanner from "../../../components/ads/AdBanner";
import ads from "../../../components/ads/AdsConst";
import { Fragment } from "react";

declare global {
  interface GoogleTag {
    display: any;
  }
  interface Window {
    googletag: any;
  }
}

const HomeCarpet = () => {
  const [membersCarpet, setMembersCarpet] = useState<
    MemberCarpet[] | null | undefined
  >([]);
  const [hasMoreData, setHasMoreData] = useState<boolean>(false);
  const [nextPageNumber, setNextPageNumber] = useState<number>(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { homeFilterCategory, needToRefresh: HomeRefresh } = useSelector(
    (state: RootState) => state.carpet
  );
  const { memberCode: myMemberCode } = useSelector(
    (state: RootState) => state.member
  );
  const dispatch = useDispatch();
  const location = useLocation();

  const adsArray = ads.map((ad: { id: string; path: string }) => (
    <div>
      <AdBanner id={`${ad.id}`} path={`${ad.path}`} />
    </div>
  ));

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // useDfpSlot({
  //    path: '/20136556/600x400_bonakir',
  //    size: [400, 600],
  //    id: 'div-gpt-ad-1651067781430-0',
  //    ref: adRef,
  // });

  // useEffect(() => {
  //    if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(position => {
  //          console.log('location enabled');
  //       }, handleBlockedLocation)
  //    }
  // }, [])

  // const handleBlockedLocation = () => {
  //    NiceModal.show("action_modal", {
  //       onNext: () => history.goBack(),
  //       headerTitle: "הרשאת מיקום",
  //       contentTitle: "הסבר על חשיבות הרשאת מיקום",
  //       seconderyButtonText: "בהזדמנות אחרת",
  //       primaryButtonText: "אישור",
  //       showCloseButton: true,
  //       showSeconderyButton: true
  //    });
  // };

  useEffect(() => {
    setUsers();
  }, [myMemberCode, homeFilterCategory]);

  useEffect(() => {
    if (HomeRefresh) {
      setUsers();
      dispatch(setNeedToRefresh(false));
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
    }
  }, [HomeRefresh]);

  const setUsers = async () => {
    setNextPageNumber(1);
    setIsLoading(true);
    const members = await getUsers(1);

    setMembersCarpet(members);
    setIsLoading(false);
    window.scrollTo(0, 0);
  };

  const getUsers = async (page: number): Promise<any> => {
    try {
      let data: any = {};

      console.log("getUsers homeFilterCategory: ", homeFilterCategory);
      // debugger;

      if (homeFilterCategory.value !== HomeCarpetFilterCategory.TAG) {
        data = await getHomeMembers(
          myMemberCode,
          homeFilterCategory.value,
          page
        );

        console.log("getUsers getHomeMembers data", data);
      } else {
        if (homeFilterCategory.tagValue) {
          data = await getHomeMembersByTag(
            myMemberCode,
            homeFilterCategory.tagValue,
            page
          );
        }
      }
      if (data.data.currentPage === data.data.totalPages) {
        setHasMoreData(false);
      }
      const {
        data: { items, links },
      } = data;
      if (links) handleHasMoreData(links);

      return items;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const fetchingMorData = async () => {
    try {
      const members = await getUsers(nextPageNumber);
      const uniqueMembers = members.filter((item: MemberCarpet) => {
        return !membersCarpet!.some(
          (member: MemberCarpet) => item.memberCode === member.memberCode
        );
      });
      setMembersCarpet((carpets) => [...carpets!, ...uniqueMembers]);
    } catch (error) {
      console.log(error);
    }
  };

  const handleHasMoreData = (links: any) => {
    if (links?.Next) {
      setNextPageNumber((count) => count + 1);
      setHasMoreData(true);
    } else {
      setNextPageNumber(-1);
      setHasMoreData(false);
    }
  };

  const advacnedSearchlink = usePrepareLink({
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.advancedSearch,
    },
    keepOldQuery: true,
  });

  //TODO: Just for debugging purposes
  useEffect(() => {
    console.log({ membersCarpet });
  }, [membersCarpet]);

  return (
    <>
      <div className="top_sec desk wf-section">
        <NavLink className="top_logo_bounakir w-inline-block" to={HOMEPAGE}>
          <img
            onClick={() => window.location.reload()}
            src="assets/images/shoshke_logo.svg"
            loading="lazy"
          />
        </NavLink>
        <div className="top_content w-clearfix">
          <HomeFilter memberCode={myMemberCode} />
          {/* <Link to={advacnedSearchlink} className="preference_link w-inline-block">
                  <div className="preference_icon">
                     <img src="assets/images/ic_pref_red.svg" loading="lazy" alt="" />

                  </div>
                  <div className="preference_txt">ההעדפות שלי</div>
               </Link> 
               
               */}
        </div>
      </div>

      <div className="content_sec desk wf-section">
        {isLoading ? (
          <HomeCarpetLoader count={9} />
        ) : membersCarpet?.length === 0 ? (
          <EmptyCarpetPlaceHolder
            imgSrc="/assets/images/no_pict.png"
            title="לא מצאנו אנשים לפי ההעדפות שבחרת"
            subTitle="אבל קל מאוד לשנות את זה - אפשר לערוך את ההעדפות ולראות יותר אנשים"
            isHomeCarpet={true}
          />
        ) : membersCarpet !== null && membersCarpet !== undefined ? (
          <InfiniteScroll
            dataLength={membersCarpet!.length} //This is important field to render the next data
            next={fetchingMorData}
            //initialScrollY={previousScrollY}
            hasMore={hasMoreData}
            loader={null}
          >
            <ul className="gallery_list prof w-list-unstyled">
              {membersCarpet.map((member, index): any => {
                if (
                  index !== 0 &&
                  index % 11 === 0 &&
                  adsArray[0] !== undefined
                ) {
                  return (
                    <Fragment key={index + "reactFragmentId"}>
                      <li
                        className="gallery_list_item prof"
                        id="carpet-ad-container"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {adsArray.pop()}
                      </li>
                      <ProfileItem key={member.memberCode} member={member} />
                    </Fragment>
                  );
                } else {
                  return (
                    <ProfileItem key={member.memberCode} member={member} />
                  );
                }
              })}

              {!hasMoreData && <EndOfFeedCarpet />}
            </ul>
          </InfiniteScroll>
        ) : (
          <div>אירעה שגיאה בטעינת המשתמשים</div>
        )}

        {/* {membersCarpet.length === 0 ? <div className="gallery_prof_info " style={{ display: 'flex', alignItems: 'center', }}>
               <Link to={advacnedSearchlink} className="button">
                  <div>להעדפות שלי</div>
               </Link>
            </div> : null} */}
      </div>
    </>
  );
};

export default HomeCarpet;
